var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-grow @lg/panel:gl-items-center"},[_c('gl-tabs',{attrs:{"content-class":"gl-py-0"}},_vm._l((_vm.tabs),function(tab){return _c('gl-tab',{key:tab.text,attrs:{"title":tab.text,"active":tab.active},on:{"click":function($event){return _vm.navigateTo(tab.route)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }